import Vue from "vue";
import Router from "vue-router";
import auth from "./auth";
import appInfo from "./app-info";

Vue.use(Router);

const routes = [
  { path: '/login', name: 'login', component: () => import('./views/login-form.vue'), meta: { noAuth: true } },
  { path: '/no-permission', name: 'noPermission', component: () => import('./views/no-permission.vue') },
  { path: '/home', name: 'home', component: () => import('./views/home-page.vue') },
  { path: '/gth', name: 'gth', component: () => import('./views/CustomerPage.vue') },
  { path: '/clue', name: 'clue', component: () => import('./views/CluePage.vue') },
  { path: '/taxpayer', name: 'taxpayer', component: () => import('./views/personGroup/Taxpayer.vue') },
  { path: '/texin', name: 'texin', component: () => import('./views/personGroup/TeXinQiYe.vue') },
  { path: '/taxa', name: 'taxa', component: () => import('./views/personGroup/TaxA.vue') },
  { path: '/selfemployee', name: 'selfemployee', component: () => import('./views/personGroup/SelfEmployeeCode.vue') },
  { path: '/winning', name: 'winning', component: () => import('./views/personGroup/WinningCompany.vue') },
  { path: '/ecomEnterprise', name: 'ecomEnterprise', component: () => import('./views/personGroup/EcomEnterprise.vue') },
  { path: '/foreignTrade', name: 'foreignTrade', component: () => import('./views/personGroup/ForeignTrade.vue') },
  { path: '/foreignTradeTwo', name: 'foreignTradeTwo', component: () => import('./views/personGroup/ForeignTradeTwo.vue') },
  { path: '/bill', name: 'bill', component: () => import('./views/BillPage.vue') },
  { path: '/kefu', name: 'kefu', component: () => import('./views/KeFuPage.vue') },
  { path: '/custom-service', name: 'customService', component: () => import('./views/custom-service-page.vue') },
  { path: '/batch-query', name: 'batchQuery', component: () => import('./views/BatchQueryPage.vue') },
];

// 内网版本专属路由
if (appInfo.showAnnualCompany) {
  routes.push({ path: '/annualCompany', name: 'annualCompany', component: () => import('./views/AnnualCompanyPage.vue') });
}

routes.push({ path: '/', redirect: '/home' });
routes.push({ path: '*', redirect: '/home' });

const router = new Router({ routes });

router.beforeEach((to, from, next) => {
  if (to.matched.some(r => r.meta.noAuth)) { next() }
  else if (!auth.loggedIn()) { next({ path: '/login', query: { redirect: to.fullPath } }) }
  else if (!auth.hasRoutePermission(to.path)) { next('/no-permission') }
  else { next() }
});

export default router;
